import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxModule } from 'primeng/checkbox';
import { LocationsService } from '../../locations/state/locations.service';
import { AppointmentListModule } from '../appointment-list/appointment-list.module';
import { AppointmentListService } from '../appointment-list/state/appointment-list.service';
import { AppointmentSettingsComponent } from '../appointment-settings/appointment-settings.component';
import { AppointmentSettingsEffects } from '../appointment-settings/state/appointment-settings.effects';
import {
    AppointmentSettingsReducers,
    STORE_FEATURE_KEY_APPOINTMENT_SETTINGS
} from '../appointment-settings/state/appointment-settings.reducers';
import { AppointmentSettingsSelectors } from '../appointment-settings/state/appointment-settings.selectors';
import { AppointmentsComponent } from './appointments.component';
import { AppointmentsEffects } from './state/appointments.effects';
import { DateAppointmentService } from './state/date-appointment.service';

@NgModule({
    imports: [
        CommonModule,
        AppointmentListModule,
        RouterModule.forChild([
            {path: '', component: AppointmentsComponent}
        ]),
        StoreModule.forFeature(STORE_FEATURE_KEY_APPOINTMENT_SETTINGS, AppointmentSettingsReducers),

        EffectsModule.forFeature([AppointmentsEffects]),
        EffectsModule.forFeature([AppointmentSettingsEffects]),

        FormsModule,
        CheckboxModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    declarations: [
        AppointmentsComponent,
        AppointmentSettingsComponent
    ],
    providers: [
        AppointmentListService,
        DateAppointmentService,
        AppointmentSettingsSelectors,
        LocationsService

    ]
})
export class AppointmentsModule {
}
